import { Divider } from 'antd';
import React from 'react';
import '../../../styles/components/MarketPlace/skeletons/JobListingsSkeleton.scss';

function JobListingsSkeleton() {
  return (
    <div className='grid'>
        <div className='header-section'>
        <div className='skeleton img-section'></div>
        <div className='header-info'>
            <div className='skeleton header-text'></div>
            <div className='skeleton header-text'></div>
        </div>
        </div>
        <Divider />
        <div className='content-section'>
        <div className='skeleton header-text'></div>
        <div className='skeleton header-text'></div>
        </div>
        <div className='skeleton button'></div>
        <Divider />
        <div className='ratings-section'>
        <div className='skeleton likes-section'></div>
        <div className='white-divider-section'></div>
        <div className='skeleton likes-section'></div>
        </div>
    </div>
  )
}

export default JobListingsSkeleton;
